// extracted by mini-css-extract-plugin
module.exports = {"ShadowPageContainer":"ShadowPage_ShadowPageContainer__3HYiQ"};